import request, { query } from '../request';
import {
  GetPrototypeItem,
  GetPrototypeRequest,
  GetPrototypeResponse,
  SavePrototypeRequest,
} from './type';

export const getPrototypes = (req: GetPrototypeRequest) => {
  return request('/api/prototype/list', req) as Promise<GetPrototypeResponse>;
};

export const savePrototype = (req: SavePrototypeRequest) => {
  return request('/api/prototype/save', req) as Promise<GetPrototypeItem>;
};

export type Category = {
  name_zh: string;
  name_en: string;
  code: string;
  sizes: string[];
  weight_min_kg: number;
  weight_max_kg: number;
  standard_weight_kg: number;
  standard_length_cm: number;
  standard_width_cm: number;
  standard_height_cm: number;
};

export const getCategories = () => {
  return query<{ categories: Category[] }>('/api/prototype/categories');
};

export const createNewCategory = (payload: Category) => {
  return request<{ result: Category & { id: string } }>(
    '/api/prototype/categories/create',
    payload
  );
};

export const getPrototypeById = ({
  prototype_id,
}: {
  prototype_id: string;
}) => {
  return query<{ prototype: GetPrototypeItem }>(
    `/api/prototype/${prototype_id}`
  );
};
